import Experience from "../Experience";
import LabelGroup from "./LabelGroup";

export default class Labels {
  constructor () {
    this.experience = new Experience();

    this.group = new LabelGroup(this.experience.params.labels);
  }

  show (hotspot) {
    this.hide();

    const labels = document.querySelectorAll(`.label[data-section="${hotspot.dataset.section}"]`);

    this.isGrowth = this.experience.world.isGrowth;

    for (const label of labels) {
      if (this.isGrowth) {
        label.dataset.state = "visible";
      } else if (label.dataset.type !== "growth") {
        label.dataset.state = "visible";
      }
    }
  };

  hide () {
    const labels = document.querySelectorAll(".label[data-state='visible']");

    for (const label of labels) {
      label.dataset.state = "hidden";
    }
  }
}